export const OM4A_TYPES = ['IAMC'] as const

export type OM4ALayerType = (typeof OM4A_TYPES)[number]

export function isOM4ALayerType(layerType: string): layerType is OM4ALayerType {
  return (OM4A_TYPES as readonly string[]).includes(layerType)
}
